export const DISPLAY_MODE_FULL = "full";

export const COURSE_TYPE_ONLINE = 1;
export const COURSE_TYPE_CLASSROOM = 2;
export const COURSE_TYPE_ACTIVITY = "Activity";
export const COURSE_TYPE_PROGRAM = "Program";

export const COLOR_PROGRESS = "rgba(45, 85, 40, 0.8)";

export const PROGRESS_ALL = "all";
export const FILTER_TODO = "lefttodo";
export const FILTER_DONE = "completed";
export const FILTER_ONGOING = "begun";
export const FILTER_INITIAL_TAGS = [0, 0, 0, 0, 0];
export const FILTER_PARTICIPANT_PROFILE = 2;
export const FILTER_ADMINISTRATOR_PROFILE = 3;
export const MODE_FULL = "full";
export const MODE_SIMPLE = "simple";
export const NOOFCOURSES = 5;

export const SORT_TITLE = "title";
export const SORT_LAST_LOGGED_IN = "lastloggedin";
export const SORT_CREATED_DATE = "createddate";

export const SORT_OPTIONS_ORDER = [
  { value: SORT_TITLE, label: "Lettersorting" },
  { value: SORT_LAST_LOGGED_IN, label: "Recentlyaccessed" },
  { value: SORT_CREATED_DATE, label: "Recentlyenrolled" },
];

export const SORT_OPTIONS_STATUS = [
  { value: "all", label: "all" },
  { value: "lefttodo", label: "lefttodo" },
  { value: "notstarted", label: "notstarted" },
  { value: "begun", label: "begun" },
  { value: "completed", label: "finished2" },
];

export const STORAGE_KEY_SORT_ORDER = "Mycourses_sortOrder";
export const STORAGE_KEY_FILTER_STATUS = "Mycourses_filterStatus";
export const STORAGE_KEY_LEARNING_VIEW = "Mycourses_learningView";
export const STORAGE_KEY_ADMIN_TOGGLE = "Mycourses_adminToggle";

export const CARD_IMAGE_HEIGHT = 169;
export const CARD_NO_IMAGE_HEIGHT = 122;

export const CARD_IMAGE_SETTINGS = {
  boxShadow: "lg",
  minWidth: 300,
  maxWidth: 300,
  height: 360,
  maxHeight: 360,
  margin: 1,
};

export const CARD_NO_IMAGE_SETTINGS = {
  boxShadow: "lg",
  minWidth: 300,
  maxWidth: 300,
  height: 250,
  maxHeight: 250,
  margin: 1,
};
